import { defineMessages } from 'react-intl';

export const memberDetailMessages = defineMessages({
  loadingMember: {
    id: 'MemberDetail.loadingMember',
    defaultMessage: 'Loading member…',
  },
  memberNotFound: {
    id: 'MemberDetail.memberNotFound',
    defaultMessage: 'Member not found.',
  },
  memberUnavailable: {
    id: 'MemberDetail.memberUnavailable',
    defaultMessage: 'Unable to load this member right now.',
  },
  memberNameUnavailable: {
    id: 'MemberDetail.memberNameUnavailable',
    defaultMessage: 'Name unavailable',
  },
  unknownMember: {
    id: 'MemberDetail.unknownMember',
    defaultMessage: 'Unable to load this member right now.',
  },
  menuLabel: {
    id: 'MemberDetail.menuLabel',
    defaultMessage: 'Member menu',
  },
  onboardingSnapshotLabel: {
    id: 'MemberDetail.onboardingSnapshotLabel',
    defaultMessage: 'Onboarding Snapshot',
  },
  annualReportLabel: {
    id: 'MemberDetail.annualReportLabel',
    defaultMessage: 'Annual Report',
  },
  actionPlanLabel: {
    id: 'MemberDetail.actionPlanLabel',
    defaultMessage: 'Action Plan',
  },
  aiToolsLabel: {
    id: 'MemberDetail.aiToolsLabel',
    defaultMessage: 'Zori Reports',
  },
  ruleActionAuditLabel: {
    id: 'MemberDetail.ruleActionAuditLabel',
    defaultMessage: 'Rule Actions Audit',
  },
  labsLabel: {
    id: 'MemberDetail.labsLabel',
    defaultMessage: 'Labs and Data',
  },
  surveysLabel: {
    id: 'MemberDetail.surveysLabel',
    defaultMessage: 'Surveys',
  },
  documentsLabel: {
    id: 'MemberDetail.documentsLabel',
    defaultMessage: 'Documents',
  },
  memberAppLabel: {
    id: 'MemberDetail.memberAppLabel',
    defaultMessage: 'Member App',
  },
  onboardingSnapshot: {
    id: 'MemberDetail.onboardingSnapshot',
    defaultMessage: 'Onboarding Snapshot',
  },
  onboardingSnapshotLink: {
    id: 'MemberDetail.onboardingSnapshotLink',
    defaultMessage: 'View in Onboarding Snapshot workflow',
  },
  annualReport: {
    id: 'MemberDetail.annualReport',
    defaultMessage: 'Annual Report',
  },
  actionPlan: {
    id: 'MemberDetail.actionPlan',
    defaultMessage: 'Action Plan',
  },
  aiTools: {
    id: 'MemberDetail.aiTools',
    defaultMessage: 'Zori Reports',
  },
  ruleActionAudit: {
    id: 'MemberDetail.ruleActionAudit',
    defaultMessage: 'Rule Actions Audit',
  },
  labsAndData: {
    id: 'MemberDetail.labsAndData',
    defaultMessage: 'Labs and Data',
  },
  surveys: {
    id: 'MemberDetail.surveys',
    defaultMessage: 'Surveys',
  },
  documents: {
    id: 'MemberDetail.documents',
    defaultMessage: 'Documents',
  },
  memberDocumentsDeleteColumn: {
    id: 'MemberDetail.memberDocumentsDeleteColumn',
    defaultMessage: 'Actions',
  },
  memberDocumentsDeleteButton: {
    id: 'MemberDetail.memberDocumentsDeleteButton',
    defaultMessage: 'Delete member file',
  },
  memberDocumentsDeleteConfirmTitle: {
    id: 'MemberDetail.memberDocumentsDeleteConfirmTitle',
    defaultMessage: 'Delete member file?',
  },
  memberDocumentsDeleteConfirmBody: {
    id: 'MemberDetail.memberDocumentsDeleteConfirmBody',
    defaultMessage:
      'This permanently removes this member-uploaded document from the chart. This cannot be undone.',
  },
  memberDocumentsDeleteConfirm: {
    id: 'MemberDetail.memberDocumentsDeleteConfirm',
    defaultMessage: 'Delete',
  },
  memberDocumentsDeleteCancel: {
    id: 'MemberDetail.memberDocumentsDeleteCancel',
    defaultMessage: 'Cancel',
  },
  memberDocumentsDeleteSuccess: {
    id: 'MemberDetail.memberDocumentsDeleteSuccess',
    defaultMessage:
      'File has been deleted, it may take a few seconds to disappear from the documents list',
  },
  notesLabel: {
    id: 'MemberDetail.notesLabel',
    defaultMessage: 'Notes',
  },
  notes: {
    id: 'MemberDetail.notes',
    defaultMessage: 'Notes',
  },
  notesTitle: {
    id: 'MemberDetail.notesTitle',
    defaultMessage: 'Title',
  },
  notesDate: {
    id: 'MemberDetail.notesDate',
    defaultMessage: 'Created',
  },
  notesMemberVisible: {
    id: 'MemberDetail.notesMemberVisible',
    defaultMessage: 'Member visible',
  },
  notesType: {
    id: 'MemberDetail.notesType',
    defaultMessage: 'Type',
  },
  notesAuthor: {
    id: 'MemberDetail.notesAuthor',
    defaultMessage: 'Author',
  },
  notesEmpty: {
    id: 'MemberDetail.notesEmpty',
    defaultMessage: 'No notes found',
  },
  notesError: {
    id: 'MemberDetail.notesError',
    defaultMessage: 'Error loading notes',
  },
  contentAiTools: {
    id: 'MemberDetail.contentAiTools',
    defaultMessage: 'Zori reports content goes here.',
  },
  contentPlaceholder: {
    id: 'MemberDetail.contentPlaceholder',
    defaultMessage: 'Member content goes here.',
  },
  omicsExplorer: {
    id: 'MemberDetail.omicsExplorer',
    defaultMessage: 'Omics Explorer',
  },
  omicsExplorerLabel: {
    id: 'MemberDetail.omicsExplorerLabel',
    defaultMessage: 'Omics Explorer',
  },
  elationLink: {
    id: 'MemberDetail.elationLink',
    defaultMessage: 'Elation',
  },
  chatClinicianLabel: {
    id: 'MemberDetail.chatClinicianLabel',
    defaultMessage: 'Clinician',
  },
  chatMemberHistoryLabel: {
    id: 'MemberDetail.chatMemberHistoryLabel',
    defaultMessage: 'Member History',
  },
  medications: {
    id: 'MemberDetail.medications',
    defaultMessage: 'Medications',
  },
  medicationsMedication: {
    id: 'MemberDetail.medicationsMedication',
    defaultMessage: 'Medication',
  },
  medicationsStatus: {
    id: 'MemberDetail.medicationsStatus',
    defaultMessage: 'Status',
  },
  medicationsIntent: {
    id: 'MemberDetail.medicationsIntent',
    defaultMessage: 'Intent',
  },
  medicationsDosage: {
    id: 'MemberDetail.medicationsDosage',
    defaultMessage: 'Dosage',
  },
  medicationsAuthoredOn: {
    id: 'MemberDetail.medicationsAuthoredOn',
    defaultMessage: 'Authored On',
  },
  medicationsPrescriber: {
    id: 'MemberDetail.medicationsPrescriber',
    defaultMessage: 'Prescriber',
  },
  medicationsEmpty: {
    id: 'MemberDetail.medicationsEmpty',
    defaultMessage: 'No medications found',
  },
  procedures: {
    id: 'MemberDetail.procedures',
    defaultMessage: 'Procedures',
  },
  proceduresCode: {
    id: 'MemberDetail.proceduresCode',
    defaultMessage: 'Code',
  },
  proceduresStatus: {
    id: 'MemberDetail.proceduresStatus',
    defaultMessage: 'Status',
  },
  proceduresPerformed: {
    id: 'MemberDetail.proceduresPerformed',
    defaultMessage: 'Performed',
  },
  proceduresPerformer: {
    id: 'MemberDetail.proceduresPerformer',
    defaultMessage: 'Performer',
  },
  proceduresCategory: {
    id: 'MemberDetail.proceduresCategory',
    defaultMessage: 'Category',
  },
  proceduresReason: {
    id: 'MemberDetail.proceduresReason',
    defaultMessage: 'Reason',
  },
  proceduresEmpty: {
    id: 'MemberDetail.proceduresEmpty',
    defaultMessage: 'No procedures found',
  },
  conditions: {
    id: 'MemberDetail.conditions',
    defaultMessage: 'Conditions',
  },
  conditionsCode: {
    id: 'MemberDetail.conditionsCode',
    defaultMessage: 'Code',
  },
  conditionsClinicalStatus: {
    id: 'MemberDetail.conditionsClinicalStatus',
    defaultMessage: 'Clinical Status',
  },
  conditionsVerificationStatus: {
    id: 'MemberDetail.conditionsVerificationStatus',
    defaultMessage: 'Verification Status',
  },
  conditionsOnset: {
    id: 'MemberDetail.conditionsOnset',
    defaultMessage: 'Onset',
  },
  conditionsCategory: {
    id: 'MemberDetail.conditionsCategory',
    defaultMessage: 'Category',
  },
  conditionsEmpty: {
    id: 'MemberDetail.conditionsEmpty',
    defaultMessage: 'No conditions found',
  },
  allergies: {
    id: 'MemberDetail.allergies',
    defaultMessage: 'Allergies',
  },
  allergiesAllergy: {
    id: 'MemberDetail.allergiesAllergy',
    defaultMessage: 'Allergy',
  },
  allergiesClinicalStatus: {
    id: 'MemberDetail.allergiesClinicalStatus',
    defaultMessage: 'Clinical Status',
  },
  allergiesVerificationStatus: {
    id: 'MemberDetail.allergiesVerificationStatus',
    defaultMessage: 'Verification Status',
  },
  allergiesCriticality: {
    id: 'MemberDetail.allergiesCriticality',
    defaultMessage: 'Criticality',
  },
  allergiesRecordedDate: {
    id: 'MemberDetail.allergiesRecordedDate',
    defaultMessage: 'Recorded Date',
  },
  allergiesEmpty: {
    id: 'MemberDetail.allergiesEmpty',
    defaultMessage: 'No allergies found',
  },
  cohortMismatchIntro: {
    id: 'MemberDetail.cohortMismatchIntro',
    defaultMessage: 'This member is in a different cohort.',
  },
  cohortMismatchSwitchCohort: {
    id: 'MemberDetail.cohortMismatchSwitchCohort',
    defaultMessage: 'Switch to {cohortName}',
  },
  cohortMismatchOr: {
    id: 'MemberDetail.cohortMismatchOr',
    defaultMessage: 'or',
  },
  cohortMismatchAllCohorts: {
    id: 'MemberDetail.cohortMismatchAllCohorts',
    defaultMessage: 'Switch to all cohorts',
  },
});
